import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useCallback, useId, } from 'preact/compat';
import defaultNumberFormat from '@widgets/shared/defaultNumberFormat';
import { useState } from 'react';
import Styles from './styles';
const availabilityLabels = {
    high: 'Good Availability',
    average: 'Selling Fast!',
    low: 'Almost Gone',
};
function Session(props) {
    const { session: { SessionId, StartTime, TotalPrice, Warning, Error, Availability, }, isSelected, onChange, disabledClick, activityId, isDisabled, showPriceOnBands, showSessionAvailability, productId, } = props;
    const componentID = useId();
    const [active, setActive] = useState(true);
    const handleChange = useCallback((ev) => {
        if (!isDisabled) {
            onChange(ev);
        }
        else if (activityId) {
            disabledClick(activityId, props.session);
        }
    }, [isDisabled, activityId, props]);
    // if (activityId && duration !== undefined) {
    //   console.log('activityId and duration set');
    //   setActive(useActiveTime({ activityId, session: props.session, duration }));
    // }
    return (_jsxs(Styles.Element, { children: [_jsx(Styles.Input, { id: `${productId}-${componentID}-session-${SessionId}`, type: "radio", value: SessionId, checked: isSelected, onChange: handleChange, isDisabled: isDisabled }), _jsxs(Styles.Label, { htmlFor: `${productId}-${componentID}-session-${SessionId}`, children: [_jsx(Styles.Time, { children: StartTime }), showSessionAvailability && Availability && (_jsx(Styles.Availability, { availability: Availability, children: availabilityLabels[Availability] })), showPriceOnBands && _jsx(Styles.Price, { children: `${defaultNumberFormat.format(TotalPrice ?? 0)}` })] })] }));
}
Session.defaultProps = {
    isSelected: false,
    activityId: undefined,
    showSessionAvailability: false,
};
export default Session;
